export const POWER_ASSETS_LEGENDS = {
  TRADING: "trading",
  BATTERY: "battery",
  EV: "ev"
}

export const POWER_ASSETS_COLORS = {
  [POWER_ASSETS_LEGENDS.TRADING]: "#B921A3",
  [POWER_ASSETS_LEGENDS.BATTERY]: "#6A55D0",
  [POWER_ASSETS_LEGENDS.EV]: "#8FCBD3"
}
